import { Component, HostListener } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css'],
})
export class FooterComponent {
  currentYear = new Date().getFullYear();

  @HostListener('window:scroll', [])
  onWindowScroll(): void {
    const button = document.querySelector('#scrollToTop') as HTMLElement;
    if (!button) return;

    if (window.pageYOffset > 400) {
      button.classList.add('show');
    } else {
      button.classList.remove('show');
    }
  }

  scrollToTop(): void {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }
}
